// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"TabView_tabContainer__clATQ","tabContainerAlt":"TabView_tabContainerAlt__fW_nC"};